<template>
  <div ref="chart" class="echart" :style="{ height }" />
</template>

<script>
/** ECharts 薄封装：图表与组件按需注册；option 变化走 setOption 不重建实例；点击以 chart-click 抛出 */
import * as echarts from 'echarts/core';
import { BarChart, LineChart } from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  MarkLineComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  BarChart,
  LineChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  MarkLineComponent,
  CanvasRenderer,
]);

export default {
  name: 'EChart',

  props: {
    option: { type: Object, required: true },
    height: { type: String, default: '260px' },
    /** 同一 group 的图共用悬停竖线 */
    group: { type: String, default: '' },
  },

  data() {
    return { chart: null, observer: null };
  },

  watch: {
    option: {
      deep: true,
      handler(val) {
        if (this.chart) this.chart.setOption(val, true);
      },
    },
  },

  mounted() {
    this.chart = echarts.init(this.$refs.chart);
    this.chart.setOption(this.option, true);
    this.chart.on('click', (params) => this.$emit('chart-click', params));
    if (this.group) {
      this.chart.group = this.group;
      echarts.connect(this.group);
    }
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => this.resize());
      this.observer.observe(this.$refs.chart);
    }
    window.addEventListener('resize', this.resize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },

  methods: {
    resize() {
      if (this.chart) this.chart.resize();
    },
  },
};
</script>

<style scoped>
.echart {
  width: 100%;
}
</style>
